import { CommonIdentitySharedTypes } from 'st-common/Identity/CommonIdentitySharedTypes';

export const ParticipantsIdentitySharedTypes = {
    ...CommonIdentitySharedTypes,
}